import styled from 'styled-components';
import LogoLoader from '../../assets/page-loader.gif';
import { FormText } from '../../styles/TypoStyle';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
`;

const Image = styled.img`
  margin-right: 16px;
  width: 150px;
`;

const Message = styled(FormText)`
  text-align: center;
`;

export const Loader = ({ message }: { message: string }) => {
  return (
    <Container>
      <Image src={LogoLoader} alt={LogoLoader} />
      <Message>{message}</Message>
    </Container>
  );
};
